import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const Overlay = ({
  children,
  style,
  verticallyAlignContent,
  horizontallyAlignContent,
  textAlign,
  padding,
  backgroundColor,
  backgroundImage,
  ...props
}) => (
  <div
    className="Overlay"
    {...props}
    style={{
      ...style,
      ...(
        verticallyAlignContent && {
          justifyContent: 'center',
        }
      ),
      ...(
        horizontallyAlignContent && {
          alignItems: 'center',
        }
      ),
      ...(textAlign && { textAlign }),
      ...(padding && { padding }),
      ...(backgroundColor && { backgroundColor }),
      ...(backgroundImage && {
        backgroundImage: `url(${backgroundImage})`, backgroundBlendMode: 'soft-light', backgroundRepeat: 'round', alignItems: 'center',
      }),
    }}
  >
    { children }
    <style jsx>{styles}</style>
  </div>
)

Overlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  style: PropTypes.objectOf(PropTypes.string),
  verticallyAlignContent: PropTypes.bool,
  horizontallyAlignContent: PropTypes.bool,
  textAlign: PropTypes.string,
  padding: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
}

Overlay.defaultProps = {
  children: null,
  style: {},
  verticallyAlignContent: true,
  horizontallyAlignContent: false,
  textAlign: 'center',
  padding: '24px',
  backgroundColor: '',
  backgroundImage: '',
}

export default Overlay
